import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { ParametrosMaestro, EstadoSolicitud } from 'src/app/models/common/enumModel';
import { IParametroModel } from 'src/app/models/interfaces/parametros/IParametroModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';

@Component({
  selector: 'app-parametros-configuracion-listar',
  templateUrl: './parametros-configuracion-listar.component.html',
  styleUrls: ['./parametros-configuracion-listar.component.scss']
})
export class ParametrosConfiguracionListarComponent implements OnInit {
  model!: SearchResultModel<IParametroModel[]>;

  displayedColumns: string[] = [
    'id',
    'nombre',
    'valor',
    'acciones'
  ];
  constructor(
    public dialog: MatDialog,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
    private parametroService: ParametroService) { }

  ngOnInit() {
    this.search()
  }

  search(): void{
    this.parametroService
      .getDetalles(ParametrosMaestro.PARAMETROS_CONFIGURACION)
      .subscribe((data: SearchResultModel<ParametroModel[]>) => {        
        this.model = data;
      });
  }
  
  // getPaginatorData(event: any) {
  //   this.filter.page = event.pageIndex + 1;
  //   this.filter.pageSize = event.pageSize;
  //   this.maestroDocumentoService
  //     .getListPaged(this.filter)
  //     .subscribe((data) => {
  //       this.model = data;
  //       this.resultsLength = data.total;
  //     });
  // }  

}
